import { Modal, Options } from '@fl/cmsch-fe-library';
import React, { memo, FC, useMemo, useCallback } from 'react';
import { Opt } from 'ts-opt';
import { CriteriaList } from 'api/gen/CriteriaList';
import { useOurTranslation } from 'app/translations';
import { GetCriteriaListDetailsForm } from './form';
import { GetCriteriaListDetailsFormValues } from './get-criteria-list-details-form-values';
interface Props {
  /** Whether the modal is visible. */
  visible: boolean;
  /** Saved criteria lists available to choose from. */
  criteriaLists: Opt<Array<CriteriaList>>;
  /** Handles selection submission. */
  onSubmit(animalListId: number): void;
  /** Handles cancel and close. */
  onCancel(): void;
}
const ModalGetCriteriaDetailsBase: FC<Props> = props => {
  const {
    visible,
    criteriaLists,
    onSubmit,
    onCancel
  } = props;
  const {
    t
  } = useOurTranslation('mating');
  const listsOptions: Options<number> = useMemo(() => criteriaLists.mapIn(y => ({
    value: y.id,
    label: y.editable ? y.name : `${y.name} (${t('defaultList')})`
  })).orElse([]), [criteriaLists, t]);
  const handleSubmit = useCallback(({
    criteriaListId
  }: GetCriteriaListDetailsFormValues) => {
    if (criteriaListId) onSubmit(criteriaListId);
  }, [onSubmit]);
  return <Modal title={t('chooseCriteriaList')} visible={visible} onCancel={onCancel} footer={null} data-sentry-element="Modal" data-sentry-component="ModalGetCriteriaDetailsBase" data-sentry-source-file="index.tsx">
            <GetCriteriaListDetailsForm listsOptions={listsOptions} onCancel={onCancel} onSubmit={handleSubmit} data-sentry-element="GetCriteriaListDetailsForm" data-sentry-source-file="index.tsx" />
        </Modal>;
};

/**
 * Memoized modal that selects a saved criteria list.
 *
 * @param props Saved criteria lists and modal handlers.
 * @returns The criteria-list selection modal.
 */
export const ModalGetCriteriaDetails = memo(ModalGetCriteriaDetailsBase);